import { Snippet } from "react-instantsearch";
import { styled } from "@mui/material/styles";

const StyledSnippet = styled(Snippet)(({ theme }) => ({
  fontSize: theme.fontSize.sm,
  fontWeight: theme.fontWeight[300],
  color: theme.palette_custom.darkBlue,
  height: "100%",
  "& .ais-Snippet-highlighted": {
    height: "fit-content",
    backgroundColor: theme.palette_custom.yellow,
    fontWeight: theme.fontWeight[500],
  },
}));

export default StyledSnippet;
